export { default } from './svg/logo-image.svg';
